import DocumentBlank32 from '@carbon/icons-react/es/document--blank/32';
import Png32 from '@carbon/icons-react/es/PNG/32';
import React from 'react';
import styled from 'styled-components';
import { FormAnswerImage } from 'api/form';
import { ReactComponent as CSVIcon } from 'assets/svgs/csv-type-icon.svg';
import { ReactComponent as DOCIcon } from 'assets/svgs/doc-type-icon.svg';
import { ReactComponent as PDFIcon } from 'assets/svgs/pdf-type-icon.svg';
import { Avatar } from 'components/atoms/avatar';
import { extname, isImageUrlFromExtension } from 'utils/files';

const IconAvatar = styled(Avatar).attrs({
  shape: 'square',
  size: 48,
})`
  &&&&.ant-avatar-icon {
    background-color: var(--white-100);
  }
  svg {
    width: 100%;
    height: 100%;
    background-color: var(--white-100);
  }
`;

export const AttachmentIconRenderer = ({
  element,
}: {
  element: FormAnswerImage;
}) => {
  const type = extname(element.name);
  const isImage = isImageUrlFromExtension(element.name);

  if (isImage) {
    return (
      <IconAvatar
        src={element.thumbLocation || element.location}
        icon={<Png32 />}
      />
    );
  }

  switch (type) {
    case 'pdf': {
      return <IconAvatar icon={<PDFIcon />} />;
    }

    case 'csv': {
      return <IconAvatar icon={<CSVIcon />} />;
    }

    case 'doc':
    case 'docx': {
      return <IconAvatar icon={<DOCIcon />} />;
    }

    default: {
      return <IconAvatar icon={<DocumentBlank32 />} />;
    }
  }
};

export const AttachmentCardCoverRenderer = ({
  element,
}: {
  element: FormAnswerImage;
}) => {
  const isImage = isImageUrlFromExtension(element.name);

  if (isImage) {
    return (
      <img src={element.thumbLocation || element.location} alt={element.name} />
    );
  }

  return <AttachmentIconRenderer element={element} />;
};
